import Query from '../../../components/Report';

export const query = ({ fromEnd, fromStart, toStart, toEnd }) =>
    new Query('discover-algo-comparison-authors', { fromEnd, fromStart, toStart, toEnd });
